import script from "./MatterLiensTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./MatterLiensTab.vue?vue&type=script&setup=true&lang=ts"

import "./MatterLiensTab.vue?vue&type=style&index=0&id=2675a7a3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2675a7a3"]])

export default __exports__